import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import Reveal from "@/components/Reveal";
import { PRIZES, TELEGRAM_URL } from "@/data/site";

function PrizeCard({ prize, index }) {
  return (
    <Reveal
      delay={Math.min(index * 0.06, 0.3)}
      className="h-full"
      testId={`prize-card-${prize.id}`}
    >
      <article className="group relative flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#0D111A] transition-all duration-300 hover:-translate-y-1 hover:border-[#F0B429]/50 hover:shadow-[0_20px_50px_rgba(240,180,41,0.15)]">
        <div className="relative aspect-square overflow-hidden">
          <img
            src={prize.image}
            alt={prize.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0D111A] via-transparent to-transparent" />
          {prize.tag === "Grand Prize" && (
            <span className="glass absolute left-3 top-3 rounded-full px-3 py-1 font-mono text-[9px] font-bold uppercase tracking-[0.2em] text-[#F0B429] sm:text-[10px]">
              Grand Prize
            </span>
          )}
          <span className="glass absolute bottom-3 left-3 rounded-full px-3 py-1 font-mono text-[10px] font-bold tracking-[0.15em] text-[#00F2B6] sm:text-xs">
            {prize.lots ? `${prize.lotsLabel} Lot` : "Via Admin"}
          </span>
        </div>

        <div className="flex flex-1 flex-col gap-3 p-4 sm:p-5">
          <h3 className="text-sm font-bold text-white sm:text-lg">
            {prize.name}
          </h3>
          <p className="text-xs leading-relaxed text-zinc-500 sm:text-sm">
            {prize.note ?? `Kumpulkan ${prize.lotsLabel} lot untuk menukarkan hadiah ini.`}
          </p>
          <Button
            asChild
            data-testid={`prize-ask-button-${prize.id}`}
            className="mt-auto h-11 w-full rounded-full glass text-xs font-bold text-white hover:border-teal-400/50 sm:text-sm"
          >
            <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer" onClick={() => window.fbq && window.fbq("trackCustom", "TelegramClick")}>
              Tanya Hadiah Ini
              <ArrowUpRight className="h-3.5 w-3.5 text-[#00F2B6]" />
            </a>
          </Button>
        </div>
      </article>
    </Reveal>
  );
}

export default function PrizeGrid() {
  return (
    <section id="semua-hadiah" className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#00F2B6] sm:text-sm">
            Katalog Hadiah
          </p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase tracking-tight text-white sm:text-5xl">
            Semua <span className="text-gradient-gold">Hadiah</span>
          </h2>
          <p className="mt-3 text-sm text-zinc-400 sm:text-base">
            Diurutkan dari kebutuhan lot terbesar sampai yang paling ringan.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3 sm:mt-16">
          {PRIZES.map((p, i) => (
            <PrizeCard key={p.id} prize={p} index={i} />
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 text-center text-xs text-zinc-500 sm:text-sm">
            Kebutuhan lot dan ketentuan penukaran dapat dikonfirmasi langsung
            melalui admin.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
